var _path, _rect, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilePdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2ZM18 20H6V4H13V9H18V20Z",
    fill: "#CE2030"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 10,
    width: 14,
    height: 8,
    rx: 1,
    fill: "#CE2030"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5977 16H11.4727V14.895H12.0827C12.7777 14.895 13.2477 14.375 13.2477 13.655C13.2477 12.935 12.7777 12.425 12.0827 12.425H10.5977V16ZM11.4727 14.145V13.175H11.9177C12.2077 13.175 12.3577 13.37 12.3577 13.655C12.3577 13.94 12.2077 14.145 11.9027 14.145H11.4727Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7666 16H15.0366C16.1616 16 16.8816 15.33 16.8816 14.205C16.8816 13.08 16.1616 12.425 15.0366 12.425H13.7666V16ZM14.6416 15.25V13.175H15.0016C15.5916 13.175 15.9766 13.525 15.9766 14.205C15.9766 14.89 15.6066 15.25 15.0016 15.25H14.6416Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4971 16H18.3721V14.675H19.4621V13.925H18.3721V13.175H19.6871V12.425H17.4971V16Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilePdf);
export default __webpack_public_path__ + "static/media/file_PDF.d32e48694ffd69d012f42065e51f4481.svg";
export { ForwardRef as ReactComponent };